module.exports = __webpack_public_path__ + "static/navitime-5730938eb299ff31bd3bc6f063cc8535.jpg";